import { useState, useEffect, useRef } from 'react';
import Bredcrum from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import { Tablescom } from '../../components/tablescomp';
import { userservices } from '../../services/userServices';
import { productservices } from '../../services/productServices';
import { Titlebar, Searchbox, Stockstatus, Stockstatusavailability, Importexceldata, Confirmdialog2 } from '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router";
import { supplierservices } from '../../services/supplierServices'
import { StockServices } from '../../services/stockServices';
import { Dialog } from 'primereact/dialog';
import { TabMenu } from 'primereact/tabmenu';
import { exportToExcel } from '../../helpers/exporttoexcel';
import { Toast } from "primereact/toast";
import { convertFileToBase64 } from '../../helpers/base64conversion';
import { FcRefresh } from "react-icons/fc";
import { AiOutlineRetweet } from "react-icons/ai";
import { useFormikContext, useFormik, Field, Formik, Form, FieldArray } from 'formik';

const Stocksproductreports = ({ dashboard = false }) => {
  const toast = useRef(null);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [results, setResults] = useState([]);
  const [userloaded, setUserloaded] = useState(true);
  const [stockdialog, setStockDialog] = useState(false);
  const [detailinfo, setDetailinfo] = useState({});
  const [filter, setfilter] = useState({ 'fromdate': '', 'todate': '' });
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // 🔄 dynamic page size
  const [quickFilterText, setQuickFilterText] = useState('');
  const [statusset, setStatusset] = useState('merged');
  const [visible, setVisible] = useState(false);
  const [popvisible, setPopvisible] = useState(false);
  const [viewvisible, setViewvisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const gridref = useRef();


  const items = [
    {
      label: 'Merged Stocks',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('merged'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'All Stocks',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('all'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'Available',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('available'),
      //  template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Expired',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('expired'),
      //  template: (item) => itemRenderer(item, 2)
    },
    {
      label: 'Low Stock',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('lowstock'),
      //  template: (item) => itemRenderer(item, 3)
    },
    {
      label: 'Out of Stock',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('outofstock'),
      //  template: (item) => itemRenderer(item, 3)
    },
    {
      label: 'Used',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('used'),
      //  template: (item) => itemRenderer(item, 3)
    },
    {
      label: 'Archived',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('archive'),
      //  template: (item) => itemRenderer(item, 3)
    },
    {
      label: 'Damaged',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('damaged'),
      //  template: (item) => itemRenderer(item, 3)
    },
      {
      label: 'Recently Added',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('recentlyadded'),
      //  template: (item) => itemRenderer(item, 3)
    }
  ];


  function handleStockFilter(status) {
    setStatusset(status);
    getstocks(statusset, currentPage, pageSize);
  }


  useEffect(() => {
    getstocks(statusset, currentPage, pageSize);
  }, [statusset, currentPage, pageSize]);

  useEffect(() => {
    setColDefs(getColDefs(currentPage, pageSize));
  }, [statusset, currentPage, pageSize]);

  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const getColDefs = (currentPage, pageSize) => [
    {
      headerName: "SR NO", field: "id", width: 50,
      valueGetter: (params) => {
        return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
      },
    },

    {
      headerName: "Product", field: "product_name", cellStyle: {
        whiteSpace: 'normal',
        lineHeight: '1.4',
        wordBreak: 'break-word',
        display: 'flex',
        alignItems: 'center'
      },
    },
    {
      headerName: "Product Sku", field: "product", cellStyle: {

        // whiteSpace: 'normal',
        // lineHeight: '1.4',
        // wordBreak: 'break-word'
      },
    },
    {
      headerName: "Stock date", field: "stock_date"
    },
    { headerName: "Batch No", field: "batch_number" },
    { headerName: "Stock Type", field: "stock_type", cellRenderer: (params) => {
      return(
        <>
        {params.data.stock_type == 'product' ? 
        <span className='text-primary'>{params.data.stock_type}</span>:
        <span className='text-warning'>{params.data.stock_type}</span>
        }
          
        </>
      )
    }},
    {
      headerName: "Quantity", field: "quantity", cellRenderer: (params) => {
        return (
          <>
            <span>{params.data.quantity}</span> &nbsp; <span className='text-success'>({params.data.unit_of_measurement})</span>
          </>
        )
      }
    },
    {
      headerName: "Damaged Qty", field: "damaged_quantity", cellRenderer: (params) => {
        return (
          <>
            <span>{params.data.damaged_quantity}</span> &nbsp; <span className='text-success'>({params.data.unit_of_measurement})</span>
          </>
        )
      }
    },
    {
      headerName: "Stock Status", field: "stock_status", cellRenderer: (params) => {
        return (
          <>
            <Stockstatus status={params.data.stock_status} />
            {/* <span className='text-success'>{params.data.stock_status} </span>     */}
          </>
        )
      }
    },
    // { headerName: "Unit",field: "unit_of_measurement",width:100 },
    { headerName: "Supplier", field: "supplier_name" },
    { headerName: "Remaining Quantity", field: "remaining_quantity"},
    {
      headerName: "In Stock", field: "Instock", cellRenderer: (params) => {
        return (
          <>
            {/* <button className='btn btn-primary btn-xs'><i className='fa fa-upload'></i></button> */}
            <div><Stockstatusavailability status={params.data.Instock} /></div>

            {/* <Stockstatus status={params.data.Instock}/> */}
            {/* <span className='text-success'>{params.data.stock_status} </span>     */}
          </>
        )
      }
    },
  ];
  const [colDefs, setColDefs] = useState(getColDefs(1, 5));

  const getRowClass = params => {
    if(params.data.stocktype === 'product'){
        return 'isproduct';  
    }
    else if (params.data.Instock === 'lowstock') {
      return 'low-stock';
    } else if (params.data.Instock === 'instock') {
      return 'in-stock';
    } else if (params.data.Instock === 'outofstock') {
      return 'out-of-stock';
    }
    else if (params.data.Instock === 'overstock') {
      return 'over-stock';
    }else if (params.data.stocktype === 'product'){
      return 'isproduct';  
    }
    return '';
  };

  const getstocks = async (status, page, pageSize) => {
    setUserloaded(true);
    let response = await StockServices.getProductstockreports(status, page, pageSize, { fromdate: filter.fromdate, todate: filter.todate });
    if (response.status == 200) {
      setResults(response.data.data);
      setTotalRows(response.data.total);
      setCurrentPage(response.data.current_page);
      setUserloaded(false);
    } else {
      setResults([]);
      setUserloaded(false);
    }
  }

  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getstocks(statusset, 1, newSize);       // reload with new size
  };

  const uploaddata = async (e) => {
    e.preventDefault();
    setLoading(true); // show loader
    let file = e.target.file.files[0];
    const base64 = await convertFileToBase64(file);
    StockServices.createmultistockupdate(base64).then((response) => {
      if (response.status == 200) {
        setVisible(false);
        setLoading(false); // show loader
        toast.current.show({ severity: 'success', summary: 'Stock Update', detail: response.data.data });
        getstocks(statusset, currentPage, pageSize);
      } else {
        toast.current.show({ severity: 'error', summary: 'Stock Update', detail: `${response.data.data}` });
        setVisible(false);
        setLoading(true); // show loader
      }
    }).catch((error) => {

    });
  }
  const onHide = () => {
    setVisible(false);
  };

  useEffect(() => {
    getstocks('merged', 1, 20);
  }, [filter])


  const handleExport = () => {
    exportToExcel({ data: results, filename: 'stock' });
  }
  const samplepath = "stockupdate.xlsx";
  return (
    <>
      <Toast ref={toast} />
      <Importexceldata
        visible={visible}
        onHide={onHide}
        onSubmit={uploaddata}
        samplepath={samplepath}
        loading={loading}
      />

      {dashboard ? (<>
        <div className="col-md-12 mt-3">
          {/* <div className='row'>
            <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
          </div> */}
          <div className='card'>
            <div className='card-body card-body-style'>
              {/* {DisplayComp(activeIndex)} */}
              <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange} gridref={gridref} getRowClass={getRowClass} />
            </div>
          </div>
        </div>
      </>) : (<>
      {/* <Bredcrum title={'Stocks Product Report'} divider={false} /> */}
        <div class="row">
          {/* <Titlebar text={'Stocks Report'} /> */}
          <div className="col-md-12 mt-3">
            <div className='row'>
              <div className='col-md-10'>
                <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
              </div>

              <div className='col-md-2'>
                <div>
                  <button class="export-btn form-control w-100 pull-right" onClick={() => handleExport()}>
                    <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                </div>
              </div>
            </div>
            <div className='card'>
              <div className='card-body card-body-style'>

                <Formik
                  initialValues={{}}
                  enableReinitialize={true}
                  onSubmit={async (values) => {
                    console.log("values");
                    console.log(values);
                    setfilter({ fromdate: values.fromdate, todate: values.todate });
                  }}
                >
                  <Form>
                    <div className='flex-box pb-3'>
                      <div className='flex-box flex-column date-box-style pb-2'>
                        <div className='pb-2 primary-text-color'><label>From date</label> </div>
                        <Field type="date" name="fromdate" placeholder='From date' className='primary-text-color date-input-style' />
                      </div>
                      &nbsp;
                      &nbsp;
                      &nbsp;
                    

                      <div className='flex-box flex-column date-box-style pb-2'>
                        <div className='pb-2 primary-text-color'><label>To date</label> </div>
                        <Field type="date" name="todate" placeholder='To date' className='primary-text-color date-input-style' />
                      </div>
                       &nbsp;
                       &nbsp;

                      <div className='date-box'>
                        <button type='submit' className='btn-success text-white'>Filter</button>
                      </div>
                    </div>
                  </Form>
                </Formik>

                <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                  totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                  handlePrevious={handlePrevious}
                  handlePageSizeChange={handlePageSizeChange} gridref={gridref} getRowClass={getRowClass} />
              </div>
            </div>
          </div>
        </div></>)}
    </>
  );
}
export default Stocksproductreports;